import { siteInfo } from '@/mocks/site';

interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';
  data: Record<string, unknown>;
}

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': type,
    ...data,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}

export function OrganizationSchema() {
  const data = {
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    address: {
      '@type': 'PostalAddress',
      streetAddress: siteInfo.address.street,
      addressLocality: siteInfo.address.city,
      addressRegion: siteInfo.address.region,
      postalCode: siteInfo.address.postalCode,
      addressCountry: siteInfo.address.country,
    },
    foundingDate: siteInfo.foundingDate,
  };
  return <SchemaOrg type="Organization" data={data} />;
}

export function WebsiteSchema() {
  const data = {
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    inLanguage: 'zh-CN',
  };
  return <SchemaOrg type="WebSite" data={data} />;
}

export function WebPageSchema({ pageUrl, pageTitle, pageDescription }: { pageUrl: string; pageTitle: string; pageDescription: string }) {
  const data = {
    '@type': 'WebPage',
    url: `${siteInfo.url}${pageUrl}`,
    name: pageTitle,
    description: pageDescription,
    inLanguage: 'zh-CN',
  };
  return <SchemaOrg type="WebPage" data={data} />;
}

export function BreadcrumbListSchema({ items }: { items: { name: string; item?: string }[] }) {
  const data = {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item ? `${siteInfo.url}${item.item}` : undefined,
    })),
  };
  return <SchemaOrg type="BreadcrumbList" data={data} />;
}